import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { makeRequest } from '../../../features/entry-form-v2/data/makeRequest';

export type UsersInEnterpriseData = {
	enterpriseMembers: EnterpriseMember[];
};

export const useGetAllUsersInEnterpriseProjects = (
	orgName: string,
	subscriptionId: string | null,
	props: Partial<UseQueryOptions<UsersInEnterpriseData>> = {}
) => {
	return useQuery<UsersInEnterpriseData>({
		queryKey: ['getAllCollaboratorsInEnterpriseProjects', orgName, subscriptionId],
		queryFn: async () => {
			const response = await makeRequest<GetAllCollaboratorsInEnterpriseProjectsResponse>({
				service: 'userAccount',
				method: 'getAllCollaboratorsInEnterpriseProjects',
				data: { orgName, subscriptionId }
			});

			return {
				enterpriseMembers: response.enterpriseReport.enterpriseMembers
			};
		},
		...props
	});
};

export type EnterpriseMember = {
	userid: string;
	userFirstName: string;
	userSirName: string;
	emailAddress: string;
	userType: 'internal' | 'external';
	organization: string;
	projects: { projectId: string }[];
	firstTimeAdded?: string;
};

export type GetAllCollaboratorsInEnterpriseProjectsResponse = {
	statusCode: string;
	enterpriseReport: {
		enterpriseMembers: EnterpriseMember[];
	};
};
